import { RawLocation, VueRouter } from 'vue-router/types/router'

export default function (router: VueRouter, route: RawLocation): void {
  // eslint-disable-next-line no-underscore-dangle,@typescript-eslint/naming-convention
  const _router = router as any

  _router.history.updateRoute(router.resolve(route).route)
}
